export const advertisingPrivacy='Google AdSense advertising may use cookies or local storage. Manage your consent in Privacy and cookie settings.';
export const privacyChoices='Privacy and cookie settings';
export const privacyUnavailable='Privacy settings are unavailable. Please try again later.';
